if (!customElements.get('mj-navigation')) {
  customElements.define('mj-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.desktop = this.querySelector('.mj-nav-desktop');
      this.back = this.querySelector('.mj-nav-back');
      this.back.addEventListener('click', () => {
        this.dialog.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
        this.dialog.scrollTop = 0;
        this.querySelector('.mj-nav-close').focus();
      }, options);
      this.opener = this.closest('.shopify-section').querySelector('.mj-nav-open');
      this.close = () => {
        if (this.dialog.open) this.dialog.close();
      };
      this.opener?.addEventListener('click', () => {
        this.dialog.showModal();
        document.documentElement.classList.add('mj-nav-lock');
        this.opener.setAttribute('aria-expanded', 'true');
        this.querySelector('.mj-nav-close').focus();
      }, options);
      this.querySelector('.mj-nav-close').addEventListener('click', this.close, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href],button,input,summary,[tabindex]')]
          .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('mj-nav-lock');
        this.opener?.setAttribute('aria-expanded', 'false');
        if (this.opener && getComputedStyle(this.opener).display !== 'none') this.opener.focus();
      }, options);
      this.dialog.addEventListener('click', (event) => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right)) this.close();
        if (event.target.closest('a[href]')) this.close();
      }, options);
      this.querySelectorAll('.mj-nav-category').forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (this.dialog.contains(detail)) {
            this.back.hidden = !this.dialog.querySelector('details[open]');
            this.querySelector('.mj-nav-dialog-header strong').hidden = !this.back.hidden;
          }
          if (!detail.open) return;
          const nav = detail.closest('nav');
          nav.querySelectorAll('.mj-nav-category[open]').forEach(other => {
            if (other !== detail) other.open = false;
          });
        }, options);
      });
      document.addEventListener('click', event => {
        if (!this.desktop.contains(event.target)) this.closeDesktop();
      }, options);
      this.desktop.addEventListener('focusout', event => {
        if (!this.desktop.contains(event.relatedTarget)) this.closeDesktop();
      }, options);
      this.desktop.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = this.desktop.querySelector('details[open]');
        if (current) { current.open = false; current.querySelector('summary').focus(); }
      }, options);
      this.breakpoint = matchMedia('(min-width: 768px)');
      this.breakpoint.addEventListener('change', event => {
        if (event.matches) this.close();
        else this.closeDesktop();
      }, options);
    }
    closeDesktop() {
      this.desktop.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
    }
    disconnectedCallback() {
      this.close();
      document.documentElement.classList.remove('mj-nav-lock');
      this.abort.abort();
    }
  });
}

